var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.isometric_een{fill:#F8F7C5;}\r\n\t.isometric_drie{fill:#F2D76C;}\r\n\t.isometric_vier{fill:#AD9A74;}\r\n\t.isometric_zeven{fill:#FF7344;}\r\n\t.isometric_acht{fill:#F05A28;}\r\n\t.isometric_negen{fill:#BE1E2D;}\r\n\t.isometric_tien{fill:#7BD6C4;}\r\n\t.isometric_twaalf{fill:#569080;}\r\n\t.isometric_dertien{fill:#225B49;}\r\n\t.st0{fill:#FFBB33;}\r\n\t.st1{fill:#F29227;}\r\n\t.st2{fill:#F5DF89;}\r\n\t.st3{fill:#6B9086;}\r\n\t.st4{fill:none;}\r\n\t.st5{fill:#72C0AB;}\r\n\t.st6{fill:#BE1E2D;}\r\n\t.st7{fill:#F28103;}\r\n\t.st8{fill:#225B49;}\r\n\t.st9{fill:#7BD6C4;}\r\n\t.st10{fill:#FF7344;}\r\n\t.st11{fill:#F05A28;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_zeven",
    points: "16.025,28.992 8.025,24.373 8.025,20.611 16.025,25.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_negen",
    points: "16.025,28.992 23.975,24.373 23.975,20.611 16.025,25.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_acht",
    points: "16.025,22.496 10.402,19.25 8.025,20.611 16.025,25.23 23.975,20.611 21.627,19.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_tien",
    points: "16.025,22.496 8.025,17.877 8.025,14.116 16.025,18.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_dertien",
    points: "16.025,22.496 23.975,17.877 23.975,14.116 16.025,18.734  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_twaalf",
    points: "16.025,16 10.402,12.754 8.025,14.116 16.025,18.734 23.975,14.116 21.627,12.745  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_een",
    points: "16.025,16 8.025,11.381 8.025,7.62 16.025,12.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_vier",
    points: "16.025,16 23.975,11.381 23.975,7.62 16.025,12.239  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "isometric_drie",
    points: "8.025,7.62 16.075,3.008 23.975,7.62 16.025,12.239  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.6a02924b7b513fb8b80884f3d4071804.svg";
export { ForwardRef as ReactComponent };